<div class="load-type-switch">
  @if (!isHKIACargo) {
    <div
      class="switch-icon"
      [class.active]="mode === LoadTypeEnum.TOTAL"
      [attr.data-after]="LoadTypeEnum.TOTAL"
    >
      <span class="icon-total" (click)="selectMode(LoadTypeEnum.TOTAL)"></span>
    </div>
  }
  <div
    class="switch-icon"
    [class.active]="mode === LoadTypeEnum.DIMENSIONS"
    [attr.data-after]="LoadTypeEnum.DIMENSIONS"
  >
    <span
      class="icon-dimension"
      (click)="selectMode(LoadTypeEnum.DIMENSIONS)"
    ></span>
  </div>
  <div
    class="switch-icon"
    [class.active]="mode === LoadTypeEnum.BUP"
    [attr.data-after]="LoadTypeEnum.BUP"
  >
    <span class="icon-bup" (click)="selectMode(LoadTypeEnum.BUP)"></span>
  </div>
</div>
